import React from 'react'
import s from './PanelBase.module.scss'

const ReadOnlyDriversList = ({
  base,
  drivers = [],
  driversFilter = '',
  setDriversFilter = () => {},
  loadDriversPage = () => {},
  driversPagination = {},
  expandedDriver = {},
  toggleDriver = () => {},
  title = 'Водители',
}) => {
  const safeDrivers = Array.isArray(drivers) ? drivers : []

  const vehicleBadgeClass = (d) => {
    if (d.status === 'blocked') return s.blocked
    if (d.status === 'in_route') return s.route
    if (d.status === 'in_loading') return s.loading
    return s.free
  }

  return (
    <div className={s.subPanel}>
      <div className={s.subPanelTitle}>{title}</div>

      <div className={s.searchRow}>
        <input
          className={s.searchInput}
          placeholder="Поиск по водителю..."
          value={driversFilter || ''}
          onChange={(e) => setDriversFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadDriversPage(base.id, 1, driversFilter || '') }}
        />
      </div>

      {safeDrivers.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сотрудник</th>
                  <th>Телефон</th>
                  <th>Доп. тел.</th>
                  <th>Номер машины</th>
                  <th>Модель</th>
                  <th>UID</th>
                  <th>QR</th>
                  <th>Фото</th>
                  <th>QR фото</th>
                  <th>Создано</th>
                  <th>Активность</th>
                  <th>Статус машины</th>
                </tr>
              </thead>
              <tbody>
                {safeDrivers.map((d, index) => (
                  <React.Fragment key={d.id}>
                    <tr
                      onClick={(e) => {
                        if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.tagName === 'IMG' || (e.target.closest && e.target.closest('button')))) return
                        toggleDriver(base.id, d.id)
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <td className={s.numCell}>{index + 1}</td>
                      <td className={s.nameCell}>{d.employee_name || d.employee}</td>
                      <td>{d.employee_phone || '—'}</td>
                      <td>{d.phone || '—'}</td>
                      <td style={{ fontWeight: 600 }}>{d.vehicle_number || '—'}</td>
                      <td>{d.vehicle_model || '—'}</td>
                      <td>
                        {d.uid ? (
                          <button className={s.uidBtn} onClick={(ev) => {
                            ev.stopPropagation()
                            try {
                              if (navigator?.clipboard?.writeText) {
                                navigator.clipboard.writeText(d.uid)
                              } else {
                                const ta = document.createElement('textarea')
                                ta.value = d.uid
                                document.body.appendChild(ta)
                                ta.select()
                                document.execCommand('copy')
                                ta.remove()
                              }
                            } catch (e) {}
                          }}>{d.uid}</button>
                        ) : '—'}
                      </td>
                      <td style={{ fontSize: 12, color: '#64748b' }}>{d.qrcode_scr || '—'}</td>
                      <td>
                        {d.photo ? <img className={s.thumb} src={d.photo?.url || d.photo} alt={`driver-${d.id}`} /> : '—'}
                      </td>
                      <td>
                        {d.qrcode_img ? <img className={s.thumb} src={d.qrcode_img?.url || d.qrcode_img} alt={`qr-${d.id}`} /> : '—'}
                      </td>
                      <td style={{ fontSize: 12, color: '#64748b' }}>{d.created_at}</td>
                      <td>
                        <span className={`${s.badge} ${d.is_active ? s.active : s.inactive}`}>
                          {d.is_active ? 'Активен' : 'Неактивен'}
                        </span>
                      </td>
                      <td>
                        <span className={`${s.badge} ${vehicleBadgeClass(d)}`}>
                          {d.status_display || d.status || 'Свободен'}
                        </span>
                      </td>
                    </tr>

                    {expandedDriver[base.id] === d.id && (
                      <tr className={s.subRow}>
                        <td colSpan={13}>
                          <div className={s.subContent}>
                            <div className={s.driverDetail}>
                              <div className={s.driverDetailTitle}>
                                Детали водителя: {d.employee_name || String(d.employee)}
                              </div>
                              <div className={s.detailGrid}>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Номер машины</span>
                                  <span className={s.detailVal}>{d.vehicle_number || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Модель</span>
                                  <span className={s.detailVal}>{d.vehicle_model || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Телефон сотрудника</span>
                                  <span className={s.detailVal}>{d.employee_phone || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Доп. телефон</span>
                                  <span className={s.detailVal}>{d.phone || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>UID</span>
                                  <span className={s.detailVal}>{d.uid || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>QR строка</span>
                                  <span className={s.detailVal}>{d.qrcode_scr || '—'}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Статус</span>
                                  <span className={s.detailVal}>
                                    <span className={`${s.badge} ${d.is_active ? s.active : s.inactive}`}>
                                      {d.is_active ? 'Активен' : 'Неактивен'}
                                    </span>
                                  </span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Статус машины</span>
                                  <span className={s.detailVal}>
                                    <span className={`${s.badge} ${vehicleBadgeClass(d)}`}>
                                      {d.status_display || d.status || 'Свободен'}
                                    </span>
                                  </span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>Дата создания</span>
                                  <span className={s.detailVal}>{d.created_at}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {driversPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!driversPagination.previous} onClick={() => loadDriversPage(base.id, (driversPagination.page || 1) - 1, driversFilter)}>Пред.</button>
              <span>Стр. {driversPagination.page || 1} из {Math.ceil(driversPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!driversPagination.next} onClick={() => loadDriversPage(base.id, (driversPagination.page || 1) + 1, driversFilter)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div className={s.empty}>Водители не найдены</div>
      )}
    </div>
  )
}

export default ReadOnlyDriversList
